import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import { staticURLs } from "../../config/urls";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

const DashboardVideoDialog = (props: { dialogId: string; closeDialog: any }) => {
    const isBusinessUser: boolean = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const dashboardVideoURL: string = isBusinessUser ? staticURLs.businessDashboardVideo : staticURLs.consumerDashboardVideo;
    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
    }, []);

    return (
        <React.Fragment>
            <div className="dialog-body">
                <ReactPlayer width={"100%"} playing={true} controls={true} url={dashboardVideoURL} />
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={() => props.closeDialog()}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default DashboardVideoDialog;
